// Blocking functionality
import { 
  API_BASE, stories, blockingStory, selectedBlockOption, currentCategory, isSignedIn,
  setBlockingStory, setSelectedBlockOption, setStories, setPendingFeedback
} from './state.js';
import { showToast } from './utils.js';

// Forward declarations - will be set by main.js
let loadStoriesFn = null;
let renderStoriesFn = null;

export function setDependencies(loadStories, renderStories) {
  loadStoriesFn = loadStories;
  renderStoriesFn = renderStories;
}

export function showBlockModalForStory(story) {
  if (!story || !story._meta) return;

  setBlockingStory(story);
  setSelectedBlockOption(null);

  const blockOptions = document.getElementById('block-options');
  const blockModal = document.getElementById('block-modal');

  const options = [
    { type: 'topic', value: story._meta.topic, label: 'This topic' },
    ...story._meta.sources.slice(0, 2).map(s => ({ type: 'source', value: s, label: 'This source' })),
    ...story._meta.keywords.slice(0, 1).map(k => ({ type: 'keyword', value: k, label: 'Stories with' }))
  ];

  blockOptions.textContent = '';

  options.forEach((opt, i) => {
    const label = document.createElement('label');
    label.className = 'block-option';
    label.dataset.type = opt.type;
    label.dataset.value = opt.value;

    const input = document.createElement('input');
    input.type = 'radio';
    input.name = 'block-option';
    input.value = i;

    const radio = document.createElement('span');
    radio.className = 'block-radio';

    const labelSpan = document.createElement('span');
    labelSpan.className = 'block-label';

    const typeSpan = document.createElement('span');
    typeSpan.className = 'block-label-type';
    typeSpan.textContent = opt.label;

    const valueSpan = document.createElement('span');
    valueSpan.className = 'block-label-value';
    valueSpan.textContent = opt.value;

    labelSpan.appendChild(typeSpan);
    labelSpan.appendChild(valueSpan);
    label.appendChild(input);
    label.appendChild(radio);
    label.appendChild(labelSpan);

    label.addEventListener('click', () => {
      blockOptions.querySelectorAll('.block-option').forEach(o => o.classList.remove('selected'));
      label.classList.add('selected');
      input.checked = true;
      setSelectedBlockOption({ type: opt.type, value: opt.value });
    });

    blockOptions.appendChild(label);
  });

  blockModal.classList.add('active');
}

export function openBlockModal(storyId, event) {
  event.stopPropagation();
  const story = stories.find(s => s.id === storyId);
  if (!story) return;

  if (!isSignedIn) {
    setPendingFeedback({ storyId, action: 'block', story, button: event.currentTarget });
    document.getElementById('signin-prompt-modal').classList.add('active');
    return;
  }

  showBlockModalForStory(story);
}

export function closeBlockModal() {
  document.getElementById('block-modal').classList.remove('active');
  setBlockingStory(null);
  setSelectedBlockOption(null);
}

export async function confirmBlock() {
  if (!blockingStory || !selectedBlockOption) {
    showToast('Please select what to block', 'error');
    return;
  }

  try {
    const response = await fetch(`${API_BASE}/feedback`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        storyId: blockingStory.id,
        action: 'block',
        topic: blockingStory._meta.topic,
        sources: blockingStory._meta.sources,
        blockType: selectedBlockOption.type,
        blockValue: selectedBlockOption.value
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Server error');
    }

    const blockedValue = selectedBlockOption.value;
    const blockedStoryId = blockingStory.id;

    showToast(`Blocked: ${blockedValue}`);
    closeBlockModal();

    setStories(stories.filter(s => s.id !== blockedStoryId));
    if (renderStoriesFn) renderStoriesFn();
    if (loadStoriesFn) setTimeout(() => loadStoriesFn(currentCategory), 500);
  } catch (error) {
    console.error('Failed to block:', error);
    showToast('Failed to block', 'error');
  }
}
